import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import { getEditProgramPath, getProgramPath, formatCurrency, convertUTCDateToShortForm, getCurrencySign } from '@applyboard/ui-utils';
export function formatCurrencyForProgramCard(amount, currencySign, currencyCode) {
  return parseFloat(amount) === 0 ? 'Free' : formatCurrency(amount, {
    sign: currencySign,
    code: currencyCode,
    prefix: true
  }, true, false);
}

/**
 * Returns an array of props used to render
 * ProgramCard elements based on programs fetched
 * from the API
 * @param programs - Response received from v2 similar programs API
 */
export function getProgramsProps(similarPrograms, shouldViewPublishedChip) {
  return similarPrograms === null || similarPrograms === void 0 ? void 0 : similarPrograms.data.map(function (similarProgram) {
    var _similarProgram$commi, _similarProgram$earli, _similarProgram$earli2;
    var school = similarProgram.school;
    var currencyCode = school.currency;
    var currencySign = getCurrencySign(currencyCode);
    var applicationFee = similarProgram.applicationFee === 0 ? 'Free' : formatCurrencyForProgramCard(similarProgram.applicationFee.toString(), currencySign, currencyCode);
    var commission = similarProgram.commissionAmount || similarProgram.commissionAmount === 0 ? formatCurrencyForProgramCard(((_similarProgram$commi = similarProgram.commissionAmount) === null || _similarProgram$commi === void 0 ? void 0 : _similarProgram$commi.toString()) || '0', currencySign, currencyCode) : null;
    var tuition = formatCurrencyForProgramCard(similarProgram.tuition.toString(), currencySign, currencyCode);
    var earliestIntakeStartDate = (_similarProgram$earli = similarProgram.earliestProgramIntake) === null || _similarProgram$earli === void 0 ? void 0 : _similarProgram$earli.startDate;
    var earliestIntakeDeadline = (_similarProgram$earli2 = similarProgram.earliestProgramIntake) === null || _similarProgram$earli2 === void 0 ? void 0 : _similarProgram$earli2.submissionDeadline;
    return {
      id: similarProgram.programId.toString(),
      name: similarProgram.name,
      schoolName: school.name,
      tuition: tuition,
      applicationFee: applicationFee,
      commission: commission,
      links: {
        viewPath: getProgramPath(school.slug, similarProgram.slug),
        editPath: getEditProgramPath(school.schoolGroupId, school.id, similarProgram.id)
      },
      published: shouldViewPublishedChip ? !!similarProgram.published : null,
      schoolId: school.id.toString(),
      earliestIntake: earliestIntakeStartDate && convertUTCDateToShortForm(new Date(earliestIntakeStartDate)),
      deadline: earliestIntakeDeadline && convertUTCDateToShortForm(new Date(earliestIntakeDeadline))
    };
  });
}